import React from 'react';
import PageHero from '../../components/PageHero';
import { Reveal, RevealGroup, RevealItem } from '../../components/Reveal';
import '../css/AboutUs.css';

const AboutUs = () => {
  const values = [
    { title: 'Quality', description: 'We maintain the highest standards in manufacturing and quality control to deliver superior products.' },
    { title: 'Innovation', description: 'Continuous improvement and innovation drive our product development and business processes.' },
    { title: 'Integrity', description: 'We conduct our business with honesty, transparency, and ethical practices in all interactions.' },
    { title: 'Customer Focus', description: 'Our customers are at the heart of everything we do, and we strive to exceed their expectations.' },
  ];

  const stats = [
    { value: '20+', label: 'Years of Experience' },
    { value: '50+', label: 'Countries Served' },
    { value: '10K+', label: 'Happy Customers' },
    { value: '500+', label: 'Products' },
  ];

  return (
    <div className="about-page">
      <PageHero
        eyebrow="About Apex"
        title="Two decades of precision manufacturing."
        subtitle="Learn more about our company, our values, and the team behind every tool we ship."
      />

      <section className="about-content">
        <div className="container">
          <div className="about-grid">
            <Reveal as="div" className="about-text">
              <span className="eyebrow">Our Story</span>
              <h2 className="section-title">Built on quality, trusted worldwide.</h2>
              <p>We are a leading manufacturer and exporter of high-quality painting tools, serving distributors worldwide for over 20 years. Our commitment to excellence and customer satisfaction has made us a trusted name in the industry.</p>
              <p>With state-of-the-art facilities and a dedicated team of professionals, we ensure that every product meets the highest standards of quality and reliability.</p>
            </Reveal>
            <Reveal as="div" className="about-image" delay={0.15}>
              <img src="/images/homepage/hero-section-6.png" alt="Apex team preparing export shipments" />
            </Reveal>
          </div>
        </div>
      </section>

      <section className="values-section">
        <div className="container">
          <Reveal className="section-head">
            <span className="eyebrow">What Drives Us</span>
            <h2 className="section-title">Our values.</h2>
          </Reveal>
          <RevealGroup className="values-grid">
            {values.map((value, i) => (
              <RevealItem key={i} className="value-card glass-card">
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </RevealItem>
            ))}
          </RevealGroup>
        </div>
      </section>

      <section className="stats-section">
        <div className="container">
          <RevealGroup className="stats-grid">
            {stats.map((stat, i) => (
              <RevealItem key={i} className="stat-card">
                <h3>{stat.value}</h3>
                <p>{stat.label}</p>
              </RevealItem>
            ))}
          </RevealGroup>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
